import { CalendarDotsIcon, DotsThreeCircleIcon } from '@phosphor-icons/react';
import type { CommentWithAuthor } from '@/lib/types/database';
import { formatDateTimeForList } from '@/lib/utils/date.utils';

export interface CommentProps {
  comment: CommentWithAuthor;
  isAuthor?: boolean;
  isAdminOrOwner?: boolean;
  onMenuClick?: () => void;
}

export function Comment({
  comment,
  isAuthor = false,
  isAdminOrOwner = false,
  onMenuClick,
}: CommentProps) {
  const authorName = comment.author_name || 'Unknown User';
  const formattedTimestamp = formatDateTimeForList(comment.created_at);

  function handleMenuClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    onMenuClick?.();
  }

  return (
    <div className="w-full flex flex-col text-left">
      <div className="flex flex-col gap-2">
        {/* Header */}
        <div className="flex justify-between w-full">
          <div className="flex items-center gap-2">
            <span className="text-large">{authorName}</span>
            {isAuthor && (
              <span className="px-2 py-0.5 text-xs font-medium bg-purple-500/20 text-purple-300 rounded-full">
                Author
              </span>
            )}
          </div>
          <div className="flex items-center gap-1">
            <CalendarDotsIcon size={20} weight="regular" />
            <span className="text-slate-400 text-small">{formattedTimestamp}</span>
            {isAdminOrOwner && (
              <button
                type="button"
                onClick={handleMenuClick}
                className="flex items-center gap-1 cursor-pointer ml-2"
                aria-label="Comment menu"
              >
                <DotsThreeCircleIcon size={20} weight="regular" />
              </button>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-col">
          <span className="break-words [overflow-wrap:anywhere]">
            {comment.content}
          </span>
        </div>
      </div>
    </div>
  );
}
